import { User, PostAuthDTO, AuthErrorResponse } from '@portal-front-end/models';

import { createAction, props } from '@ngrx/store';

export const authLoginType = '[Auth] Login';
export const authLogoutType = '[Auth] Logout';
export const authLoggedOutType = '[Auth] Logged out';
export const authLoginErrorType = '[Auth] Login Error';

export const authRouteToPublicType = '[Auth] Route To Public';

export const authForgotPasswordRequestType = '[Auth] Forgot Password Request';
export const authForgotPasswordSuccessType = '[Auth] Forgot Password Success';
export const authForgotPasswordErrorType = '[Auth] Forgot Password Error';

export const authResetPasswordType = '[Auth] Reset Password Request';
export const authResetPasswordSuccessType = '[Auth] Reset Password Success';
export const authResetPasswordErrorType = '[Auth] Reset Password Error';

export const authLoadUserType = '[Auth] Load user';
export const authLoadUserErrorType = '[Auth] Load user error';
export const authUserLoadedType = '[Auth] User Loaded';

export const authValidateTokenType = '[Auth] Validating token';
export const authValidateTokenSuccessType = '[Auth] Validating token success';
export const authValidateTokenErrorType = '[Auth] Validating token error';

export const authSetPasswordType = '[Auth] Setting User Password';
export const authSetPasswordSuccessType = '[Auth] Setting User Password Success';
export const authSetPasswordErrorType = '[Auth] Setting User Password Error';


export const authLogin = createAction(
    authLoginType,
    props<{ payload: PostAuthDTO }>()
);

export const authLoginError = createAction(
    authLoginErrorType,
    props<{ error: AuthErrorResponse }>()
);
export const authLogout = createAction(authLogoutType);
export const authLoggedOut = createAction(authLoggedOutType);

export const authLoadUser = createAction(
    authLoadUserType,
    props<{ isFromLoginRequest: boolean }>()
);
export const authUserLoaded = createAction(
    authUserLoadedType,
    props<{ user: User, isFromLogin: boolean }>()
);
export const authLoadUserError = createAction(
    authLoadUserErrorType,
    props<{ error: any }>()
);

export const authRouteToPublic = createAction(authRouteToPublicType);

export const authForgotPasswordRequest = createAction(
    authForgotPasswordRequestType,
    props<{ payload: {email: string} }>()
);
export const authForgotPasswordSuccess = createAction(authForgotPasswordSuccessType);
export const authForgotPasswordError = createAction(
    authForgotPasswordErrorType,
    props<{ error: any }>()
);

export const authResetPassword = createAction(
    authResetPasswordType,
    props<{ payload: { token: string, password: string } }>()
);
export const authResetPasswordSuccess = createAction(authResetPasswordSuccessType);
export const authResetPasswordError = createAction(
    authResetPasswordErrorType,
    props<{ error: any }>()
);

export const authSetPassword = createAction(
    authSetPasswordType,
    props<{ payload: { token: string, password: string } }>()
);
export const authSetPasswordSuccess = createAction(authSetPasswordSuccessType);
export const authSetPasswordError = createAction(
    authSetPasswordErrorType,
    props<{ error: any }>()
);
